import type { Messages } from '../de';

export default {
  sport: {
    run: 'Run',
    ride: 'Ride',
    swim: 'Swim',
    yoga: 'Yoga',
    strength: 'Strength',
    hike: 'Hike',
    walk: 'Walk',
    other: 'Other',
  },
  comingWith: 'Coming with {milestone}.',
  loading: 'Loading …',
  retry: 'Try again',
  loadFailed: 'Could not be loaded: {error}',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  all: 'All',
  activities: { one: '{count} activity', other: '{count} activities' },
  days: { one: '{count} day', other: '{count} days' },
  weeks: { one: '{count} week', other: '{count} weeks' },
} satisfies Messages['common'];
